import { useNavigate } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import TableStyle from '../../ui-component/TableStyle';
import { useState } from 'react';
import { Stack, Container, Typography, Box, Card, Button, TableContainer, Table, TableHead, TableRow, TableCell } from '@mui/material';
import * as React from 'react';
import { useEffect } from 'react';
import { getApi } from 'views/services/api';
import { color, maxWidth } from '@mui/system';
// ----------------------------------------------------------------------

const PoliceReports = () => {
  const [reservationData, setReservationData] = useState([]);
  const hotel = JSON.parse(localStorage.getItem('hotelData'));
  const navigate = useNavigate();

  // function for fetching all the active reservation data
  const fetchActiveReservationData = async () => {
    try {
      // const response = await getApi(`api/reservation/viewcustomerofactivereservation/${hotel?._id}`);
      const response = await getApi(`api/reservation/viewcustomerofactivereservation/${hotel?.hotelId}`);
      console.log("in police report =>", response);
      console.log('==> ==> ', response);
      setReservationData(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchActiveReservationData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  //---------------------------------------------------------------------
  const columns = [
    {
      field: `fullName`,
      headerName: 'Name',
      flex: 1,
      maxWidth: 200,
      cellClassName: 'name-column--cell name-column--cell--capitalize',
      color: 'black',
      renderCell: (params) => {
        return (
          <Box>
            <Box onClick={() => navigate(`/dashboard/customer/view/${params.row.phoneNumber}`)}>
              {params.value} 
            </Box>
          </Box>
        );
      }
    },
    {
      field: `phoneNumber`,
      headerName: 'Contact Details',
      flex: 1,
      maxWidth: 200,
      color: 'black',
      renderCell: (params) => {
        return (
          <Box>{params.row.phoneNumber} 
          <br /> {params.row.email}</Box>
        );
      }
    },
    {
      field: 'address',
      headerName: 'Address',
      flex: 1,
      maxWidth:200,
      renderCell: (params) => {
        return <Box>{params.row.address}</Box>;
      }
    },
    {
      field: 'idcardNumber',
      headerName: 'Id Card Number',
      flex: 1,
      maxWidth:130,
      renderCell: (params) => {
        return <Box>{params.row.idcardNumber}</Box>;
      }
    }
  ];

  const handlePrint = () => {
    const printWindow = window.open('', '_blank');
    printWindow.document.open();
    printWindow.document.write('<html><head><title>Police Report</title>');
    printWindow.document.write('<style>table { width: 100%; border-collapse: collapse; } th, td { border: 1px solid black; padding: 8px; text-align: left; }</style>');
    printWindow.document.write('</head><body>');
    printWindow.document.write('<div id="print-report">');
    
    // Creating a simple HTML version of the table
    printWindow.document.write(`
      <h1>Police Reports</h1>
      <table border="1" style="width: 100%; border-collapse: collapse;">
        <thead>
          <tr>
            <th>Name</th>
            <th>Contact Details</th>
            <th>Address</th>
            <th>Id Card Number</th>
          </tr>
        </thead>
        <tbody>
          ${reservationData.map(row => `
            <tr>
              <td>${row.fullName}</td>
              <td>${row.phoneNumber}<br />${row.email}</td>
              <td>${row.address}</td>
              <td>${row.idcardNumber}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
    `);
    
    printWindow.document.write('</div>');
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };
  

 

  return (
    <>
      <Container>
        <Stack direction="row" alignItems="center" mb={5} justifyContent={'space-between'}>
          <Typography variant="h4">Police Reports</Typography>
          <Button variant="contained" onClick={handlePrint}>
            Print
          </Button>
        </Stack>

        <TableStyle>
          <Box width="100%">
            <Card style={{ height: '600px', paddingTop: '15px' }}>
              <Typography variant="h4" sx={{ margin: '2px 15px' }}>
                Customers ( {reservationData?.length || 0} )
              </Typography>
              {reservationData && (
                <DataGrid 
                 
                  rows={reservationData}
                  columns={columns}
                  checkboxSelection
                  getRowId={(row) => row?._id}
                  slots={{ toolbar: GridToolbar }}
                  slotProps={{ toolbar: { showQuickFilter: true } }}
                  autoPageSize
                />
              )}
            </Card>
          </Box>
        </TableStyle>
      </Container>
    </>
  );
};

export default PoliceReports;

